export default{
	// baseURL:'http://192.168.1.168:8080/api',   //hardy.liu
	// baseURL:'https://192.168.1.168:9090/api',   //hardy.liu
	// baseURL:'http://hardy.free.idcfengye.com/api',   //hardy.liu
	baseURL: 'https://m.nxzyjyw.com/api',      		//..
	// baseURL: "https://192.168.1.110:10443/api",    //..
	method:'POST',
	headers: {'Content-Type':'application/x-www-form-urlencoded'},
	transformRequest: [
	    function(data) {
	      	let ret = ''
	      	for (let it in data) {
	        	ret += encodeURIComponent(it) +
	          	'=' +
	          	encodeURIComponent(data[it]) +
	          	'&'
	      	}
	      	return ret
	    }
	],
	timeout: 20000
}



// WEBPACK FOOTER //
// ./src/api/base.js